import React from 'react'
import styled from 'styled-components'
import { SYSTEM_USER } from '@feedyou/utils'

const DEFAULT_IMAGE = `/no-profile-pic.png`
const SYSTEM_USER_IMAGE = `/system-user-pic.png`

interface Props {
  url?: string
  name?: string
  isEditing?: boolean
  style?: React.CSSProperties
  isSystemUser?: boolean
  id?: string
}

export const UserImage: React.FC<Props> = ({ url, name, isEditing, style, id }) => {
  return (
    <Image
      style={style}
      src={url || (id === SYSTEM_USER.id && SYSTEM_USER_IMAGE) || DEFAULT_IMAGE}
      isEditing={!!isEditing}
    />
  )
}

const Image = styled.img<{ isEditing: boolean }>`
  border: ${props => `2px solid ${props.isEditing ? 'rgb(25,145,235)' : 'white'}`};
  border-radius: 50%;
  width: 100%;
  height: 100%;
`
